// src/components/LoginForm.js
import React, { Component } from 'react';
import Icon from './Icon';
import { postRequest, API_ENDPOINTS } from '../config/apiConfig';

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email:           '',
      password:        '',
      showPass:        false,
      rememberMe:      false,
      loading:         false,
      error:           '',
      success:         false,
      loggedUser:      null,

      // Doctor ID modal
      showDoctorModal: false,
      doctorId:        '',
      doctorIdError:   '',
      doctorLoading:   false,

      // Forgot password modal
      showForgotModal:  false,
      forgotEmail:      '',
      forgotLoading:    false,
      forgotError:      '',
      forgotSuccess:    false,

      // Change password screen
      showChangePass:   false,
      changeEmail:      '',
      newPassword:      '',
      confirmPassword:  '',
      changeLoading:    false,
      changeError:      '',
      changeSuccess:    false,
      showNewPass:      false,
      showConfirmPass:  false,
    };
  }

  /* ── Validation ─────────────────────────────────────────────── */
  validate() {
    const { email, password } = this.state;
    if (!email.trim())                               return 'Email address is required.';

    if (!password)                                   return 'Password is required.';
    if (password.length < 6)                         return 'Password must be at least 6 characters.';
    return '';
  }

  /* ── Main login submit ──────────────────────────────────────── */
  async handleSubmit(e) {
    e.preventDefault();

    const error = this.validate();
    if (error) { this.setState({ error }); return; }

    const { email, password } = this.state;
    const payload = {
      email:    email.trim().toLowerCase(),
      password: password,
    };

    this.setState({ loading: true, error: '' });

    try {
      const response = await postRequest(API_ENDPOINTS.LOGIN, payload);
      const data     = await response.json();

      console.log('Login API response:', data);

      if (response.ok) {
        const userdata = Array.isArray(data) ? data[0] : data;
        const user     = userdata.data ? userdata.data[0] : userdata;

        if (!user || !user.PersonID) {
          this.setState({ loading: false, error: 'Login failed: invalid response from server.' });
          return;
        }

        // Save complete profile so any page can read all fields
        const loggedUser = {
          personId:   user.PersonID,
          name:       `${user.FirstName || ''} ${user.LastName || ''}`.trim() || email,
          email:      user.Email       || email,
          role:       user.PersonType  || 'user',
          // ── Full profile fields (used by Book Appointment prefill) ──
          firstName:  user.FirstName   || '',
          middleName: user.MiddleName  || '',
          lastName:   user.LastName    || '',
          dob:        user.DOB         || '',
          gender:     user.Gender      || '',
          bloodGroup: user.BloodGroup  || '',
          mobile:     user.Phone       || '',
          phone:      user.Phone       || '',
          city:       user.City        || '',
          state:      user.State       || '',
          country:    user.Country     || '',
        };

        localStorage.setItem('dg_user', JSON.stringify(loggedUser));

        this.setState({ loading: false, success: true, loggedUser });

        setTimeout(() => {
          if (this.props.onLogin) this.props.onLogin(loggedUser);
        }, 1200);

      } else {
        const serverError = data.message || data.error || 'Invalid email or password. Please try again.';
        this.setState({ loading: false, error: serverError });
      }

    } catch (err) {
      console.error('Login error:', err);
      this.setState({ loading: false, error: 'Unable to connect to the server. Please check your connection.' });
    }
  }

  /* ── Doctor ID submit ───────────────────────────────────────── */
  async handleDoctorLogin() {
    const { doctorId } = this.state;

    if (!doctorId.trim()) {
      this.setState({ doctorIdError: 'Doctor ID is required.' });
      return;
    }

    this.setState({ doctorLoading: true, doctorIdError: '' });

    try {
      // Call API to verify Doctor ID
      // Replace with your actual doctor-verify endpoint
      const response = await postRequest(API_ENDPOINTS.DOCTOR_LOGIN || API_ENDPOINTS.LOGIN, {
        doctor_id: doctorId.trim(),
      });

      const data = await response.json();

      console.log('Doctor login response:', data);

      if (response.ok) {
        const userdata = Array.isArray(data) ? data[0] : data;
        const user     = userdata.data ? userdata.data.Doctor[0] : userdata;

        console.log("user = ",user)
        console.log(userdata);
        

        const loggedUser = {
          personId: user?.DoctorID,
          name:     user ? `${user.FirstName} ${user.LastName}`.trim() : `Doctor ${doctorId}`,
          email:    user?.Email      || '',
          role:     'doctor',
          doctorId: doctorId.trim(),
        };

        localStorage.setItem('dg_user', JSON.stringify(loggedUser));

        this.setState({ doctorLoading: false, showDoctorModal: false });

        if (this.props.onLogin) this.props.onLogin(loggedUser);

      } else {
        this.setState({
          doctorLoading: false,
          doctorIdError: data.message || data.error || 'Invalid Doctor ID. Please try again.',
        });
      }

    } catch (err) {
      console.error('Doctor login error:', err);
      this.setState({ doctorLoading: false, doctorIdError: 'Unable to connect to server.' });
    }
  }

  /* ── Render ─────────────────────────────────────────────────── */
  /* ── Forgot password: check email exists ───────────────────── */
  async handleForgotSubmit() {
    const { forgotEmail } = this.state;
    if (!forgotEmail.trim()) { this.setState({ forgotError: 'Please enter your email address.' }); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(forgotEmail)) { this.setState({ forgotError: 'Enter a valid email address.' }); return; }

    this.setState({ forgotLoading: true, forgotError: '' });
    try {
      const res  = await postRequest(API_ENDPOINTS.FORGOT_PASSWORD, { email: forgotEmail.trim().toLowerCase() });
      const data = await res.json();
      console.log('Forgot password response:', data);

      if (data.status || data.success || res.ok) {
        // Email exists → close modal, open change password screen
        this.setState({ forgotLoading: false, showForgotModal: false, showChangePass: true, changeEmail: forgotEmail.trim().toLowerCase(), changeError: '', changeSuccess: false, newPassword: '', confirmPassword: '' });
      } else {
        this.setState({ forgotLoading: false, forgotError: data.message || 'Email not found. Please check and try again.' });
      }
    } catch (err) {
      this.setState({ forgotLoading: false, forgotError: 'Something went wrong. Please try again.' });
    }
  }
  /* ── Change password submit ──────────────────────────────────── */
  
  async handleChangePassword() {
    const { changeEmail, newPassword, confirmPassword } = this.state;
    if (!newPassword)                        { this.setState({ changeError: 'New password is required.' }); return; }
    if (newPassword.length < 6)              { this.setState({ changeError: 'Password must be at least 6 characters.' }); return; }
    if (newPassword !== confirmPassword)     { this.setState({ changeError: 'Passwords do not match.' }); return; }

    this.setState({ changeLoading: true, changeError: '' });
    try {
      const res  = await postRequest(API_ENDPOINTS.RESET_PASSWORD, { email: changeEmail, newPassword });
      const data = await res.json();
      console.log('Reset password response:', data);

      if (data.status || data.success || res.ok) {
        this.setState({ changeLoading: false, changeSuccess: true });
        // After 2s go back to login
        setTimeout(() => this.setState({ showChangePass: false, changeSuccess: false }), 2000);
      } else {
        this.setState({ changeLoading: false, changeError: data.message || 'Could not update password. Please try again.' });
      }
    } catch (err) {
      this.setState({ changeLoading: false, changeError: 'Something went wrong. Please try again.' });
    }
  }

  render() {
    const {
      email, password, showPass, rememberMe,
      loading, error, success, loggedUser,
      showDoctorModal, doctorId, doctorIdError, doctorLoading,
      showForgotModal, forgotEmail, forgotLoading, forgotError, forgotSuccess,
      showChangePass, newPassword, confirmPassword, changeLoading, changeError, changeSuccess, showNewPass, showConfirmPass, changeEmail,
    } = this.state;

    /* ── Change Password screen ── */
    if (showChangePass) {
      const inp = { width:'100%', height:48, padding:'0 44px 0 14px', border:'1.5px solid #dde2f0', borderRadius:12, fontSize:14, fontFamily:'inherit', outline:'none', boxSizing:'border-box' };
      return (
        <div style={{ animation:'authFadeUp 0.4s ease both' }}>
          <div className="auth-form-header">
            <div style={{ width:52, height:52, borderRadius:14, background:'#E8F1FF', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:16 }}>
              <Icon name="lock" size={24} color="var(--brand)" />
            </div>
            <h2 className="auth-form-title">Set New Password</h2>
            <p className="auth-form-subtitle">Enter a new password for <strong>{changeEmail}</strong></p>
          </div>

          {changeSuccess ? (
            <div style={{ textAlign:'center', padding:'24px 0' }}>
              <div style={{ width:56, height:56, borderRadius:14, background:'#E6FAF5', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 14px' }}>
                <Icon name="check" size={28} color="#059669" />
              </div>
              <div style={{ fontWeight:700, fontSize:17, color:'#059669', marginBottom:6 }}>Password Updated!</div>
              <p style={{ color:'#6b748c', fontSize:13 }}>Redirecting you to sign in…</p>
            </div>
          ) : (
            <>
              {changeError && (
                <div className="auth-alert auth-alert-error" style={{ marginBottom:14 }}>
                  <Icon name="alert" size={14} color="var(--danger)" /> {changeError}
                </div>
              )}

              <div className="auth-field" style={{ marginBottom:14 }}>
                <label className="auth-field-label">New Password</label>
                <div style={{ position:'relative' }}>
                  <input type={showNewPass ? 'text' : 'password'} style={inp}
                    placeholder="Min. 6 characters" value={newPassword}
                    onChange={e => this.setState({ newPassword: e.target.value, changeError: '' })} />
                  <button type="button" onClick={() => this.setState(s => ({ showNewPass: !s.showNewPass }))}
                    style={{ position:'absolute', right:14, top:'50%', transform:'translateY(-50%)', border:'none', background:'none', cursor:'pointer', fontSize:12, color:'#6b748c', fontFamily:'inherit' }}>
                    {showNewPass ? 'Hide' : 'Show'}
                  </button>
                </div>
              </div>

              <div className="auth-field" style={{ marginBottom:20 }}>
                <label className="auth-field-label">Confirm Password</label>
                <div style={{ position:'relative' }}>
                  <input type={showConfirmPass ? 'text' : 'password'} style={inp}
                    placeholder="Re-enter password" value={confirmPassword}
                    onChange={e => this.setState({ confirmPassword: e.target.value, changeError: '' })} />
                  <button type="button" onClick={() => this.setState(s => ({ showConfirmPass: !s.showConfirmPass }))}
                    style={{ position:'absolute', right:14, top:'50%', transform:'translateY(-50%)', border:'none', background:'none', cursor:'pointer', fontSize:12, color:'#6b748c', fontFamily:'inherit' }}>
                    {showConfirmPass ? 'Hide' : 'Show'}
                  </button>
                </div>
              </div>

              <button className="auth-btn auth-btn-primary" style={{ width:'100%' }}
                onClick={() => this.handleChangePassword()} disabled={changeLoading}>
                {changeLoading ? 'Updating…' : 'Update Password →'}
              </button>

              <button type="button" style={{ width:'100%', marginTop:10, border:'none', background:'none', color:'#6b748c', fontSize:13, cursor:'pointer', fontFamily:'inherit' }}
                onClick={() => this.setState({ showChangePass: false })}>
                ← Back to Sign In
              </button>
            </>
          )}
        </div>
      );
    }

    /* ── Success screen ── */
    if (success && loggedUser) {
      return (
        <div className="auth-success-screen">
          <div className="auth-success-icon">
            <Icon name="check" size={34} color="var(--success)" />
          </div>
          <div className="auth-success-title">Welcome back!</div>
          <p className="auth-success-sub">
            Signed in successfully. Redirecting to your dashboard…
          </p>
          <div className="auth-success-detail">
            {[
              { k: 'Name',  v: loggedUser.name  },
              { k: 'Email', v: loggedUser.email  },
              { k: 'Role',  v: loggedUser.role.charAt(0).toUpperCase() + loggedUser.role.slice(1) },
            ].map((row, i) => (
              <div key={i} className="auth-success-row">
                <span className="auth-success-key">{row.k}</span>
                <span className="auth-success-val">{row.v}</span>
              </div>
            ))}
          </div>
        </div>
      );
    }

    return (
      <>
        <div style={{ animation: 'authFadeUp 0.4s ease both' }}>

          {/* ── Header ── */}
          <div className="auth-form-header">
            <h2 className="auth-form-title">Welcome back 👋</h2>
            <p className="auth-form-subtitle">
              Sign in with your credentials. Your role will be loaded automatically.
            </p>
          </div>

          {/* ── Error alert ── */}
          {error && (
            <div className="auth-alert error">
              <Icon name="alert" size={15} color="var(--error)" />
              {error}
            </div>
          )}

          {/* ── Form ── */}
          <form onSubmit={e => this.handleSubmit(e)} noValidate>

            {/* Email */}
            <div className="auth-field">
              <label className="auth-field-label">
                Email Address <span className="auth-required">*</span>
              </label>
              <div className="auth-input-wrap">
                <span className="auth-input-icon">
                  <Icon name="mail" size={16} />
                </span>
                <input
                  type="email"
                  className={`auth-input${error && !email ? ' error' : ''}`}
                  placeholder="you@dgdoctor.in"
                  value={email}
                  onChange={e => this.setState({ email: e.target.value, error: '' })}
                  autoComplete="email"
                  disabled={loading}
                />
              </div>
            </div>

            {/* Password */}
            <div className="auth-field">
              <div className="auth-field-label">
                <span>Password <span className="auth-required">*</span></span>
                <button type="button" className="auth-forgot"
                  onClick={() => this.setState({ showForgotModal: true, forgotEmail: '', forgotError: '', forgotSuccess: false })}>
                  Forgot password?
                </button>
              </div>
              <div className="auth-input-wrap">
                <span className="auth-input-icon">
                  <Icon name="lock" size={16} />
                </span>
                <input
                  type={showPass ? 'text' : 'password'}
                  className={`auth-input has-action${error && !password ? ' error' : ''}`}
                  placeholder="Enter your password"
                  value={password}
                  onChange={e => this.setState({ password: e.target.value, error: '' })}
                  autoComplete="current-password"
                  disabled={loading}
                />
                <button
                  type="button"
                  className="auth-input-toggle"
                  onClick={() => this.setState(s => ({ showPass: !s.showPass }))}
                >
                  <Icon name={showPass ? 'eyeOff' : 'eye'} size={14} />
                  {showPass ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>

            {/* Remember me */}
            <div
              className="auth-check-row"
              onClick={() => this.setState(s => ({ rememberMe: !s.rememberMe }))}
            >
              <div className={`auth-checkbox${rememberMe ? ' checked' : ''}`}>
                {rememberMe && <Icon name="check" size={11} color="#fff" />}
              </div>
              <span className="auth-check-text">Keep me signed in for 30 days</span>
            </div>

            {/* Submit */}
            <button type="submit" className="auth-btn" disabled={loading}>
              {loading ? (
                <>
                  <Icon name="spinner" size={18} color="#fff" className="auth-btn-spinner" />
                  Signing in…
                </>
              ) : (
                <>
                  Sign In
                  <Icon name="chevronR" size={18} color="#fff" />
                  <span className="auth-btn-shimmer" />
                </>
              )}
            </button>

          </form>

          {/* ── Quick Access ── */}
          <div className="auth-divider">quick access</div>

          <div className="auth-quick-access">

            {/* Guest Patient */}
            <button
              type="button"
              className="auth-quick-btn auth-quick-patient"
              onClick={() => {
                const guestUser = {
                  personId: 'GUEST',
                  name:     'Guest Patient',
                  email:    '',
                  role:     'patient',
                  token:    null,
                  isGuest:  true,
                };
                if (this.props.onLogin) this.props.onLogin(guestUser);
              }}
            >
              <div className="auth-quick-icon auth-quick-icon-patient">
                <span style={{ fontSize: 18 }}>🧑</span>
              </div>
              <div className="auth-quick-text">
                <span className="auth-quick-label">Continue as Patient</span>
                <span className="auth-quick-sub">No login required</span>
              </div>

            </button>

            {/* Doctor login */}
            {/* <button
              type="button"
              className="auth-quick-btn auth-quick-doctor"
              onClick={() => this.setState({ showDoctorModal: true, doctorId: '', doctorIdError: '' })}
            >
              <div className="auth-quick-icon auth-quick-icon-doctor">
                <span style={{ fontSize: 18 }}>👨‍⚕️</span>
              </div>
              <div className="auth-quick-text">
                <span className="auth-quick-label">Login as Doctor</span>
                <span className="auth-quick-sub">Enter your Doctor ID</span>
              </div>

            </button> */}

          </div>

        </div>

        {/* ════════════════════════════════════════
            DOCTOR ID MODAL
        ════════════════════════════════════════ */}
        {showDoctorModal && (
          <div
            className="auth-modal-overlay"
            onClick={e => {
              if (e.target === e.currentTarget)
                this.setState({ showDoctorModal: false });
            }}
          >
            <div className="auth-modal">

              {/* Modal header */}
              <div className="auth-modal-header">
                <div className="auth-modal-title-wrap">
                  <div className="auth-modal-icon">
                    <span style={{ fontSize: 22 }}>👨‍⚕️</span>
                  </div>
                  <div>
                    <div className="auth-modal-title">Doctor Login</div>
                    <div className="auth-modal-subtitle">Enter your Doctor ID to access the dashboard</div>
                  </div>
                </div>
                <button
                  className="auth-modal-close"
                  onClick={() => this.setState({ showDoctorModal: false })}
                >
                  <Icon name="close" size={18} />
                </button>
              </div>

              {/* Modal body */}
              <div className="auth-modal-body">

                {/* Doctor ID field */}
                <div className="auth-field">
                  <label className="auth-field-label">
                    Doctor ID <span className="auth-required">*</span>
                  </label>
                  <div className="auth-input-wrap">
                    <span className="auth-input-icon">
                      <Icon name="id" size={16} />
                    </span>
                    <input
                      type="text"
                      className={`auth-input${doctorIdError ? ' error' : ''}`}
                      placeholder="e.g. DG1"
                      value={doctorId}
                      onChange={e => this.setState({ doctorId: e.target.value, doctorIdError: '' })}
                      disabled={doctorLoading}
                      autoFocus
                      onKeyDown={e => { if (e.key === 'Enter') this.handleDoctorLogin(); }}
                    />
                  </div>
                  {doctorIdError && (
                    <div className="auth-field-error">
                      <Icon name="alert" size={12} color="var(--error)" />
                      {doctorIdError}
                    </div>
                  )}
                </div>

                <div className="auth-alert info" style={{ marginBottom: 0 }}>
                  <Icon name="info" size={14} color="var(--blue-dark)" />
                  <span>Your Doctor ID was provided by the hospital administrator.</span>
                </div>

              </div>

              {/* Modal footer */}
              <div className="auth-modal-footer">
                <button
                  type="button"
                  className="auth-modal-cancel"
                  onClick={() => this.setState({ showDoctorModal: false })}
                  disabled={doctorLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="auth-modal-submit"
                  onClick={() => this.handleDoctorLogin()}
                  disabled={doctorLoading || !doctorId.trim()}
                >
                  {doctorLoading ? (
                    <>
                      <Icon name="spinner" size={16} color="#fff" className="auth-btn-spinner" />
                      Verifying…
                    </>
                  ) : (
                    <>
                      <Icon name="heartbeat" size={16} color="#fff" />
                      Access Doctor Dashboard
                    </>
                  )}
                </button>
              </div>

            </div>
          </div>
        )}
      {/* ── Forgot Password Modal ── */}
      {showForgotModal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.45)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}
          onClick={e => { if (e.target === e.currentTarget) this.setState({ showForgotModal: false }); }}>
          <div style={{ background:'#fff', borderRadius:20, padding:'32px 28px', width:'100%', maxWidth:400, boxShadow:'0 20px 60px rgba(0,0,0,.2)', position:'relative' }}>

            {/* Close */}
            <button onClick={() => this.setState({ showForgotModal: false })}
              style={{ position:'absolute', top:16, right:16, border:'none', background:'#f1f5f9', borderRadius:8, width:32, height:32, cursor:'pointer', fontSize:16, color:'#6b748c', display:'flex', alignItems:'center', justifyContent:'center' }}>
              ✕
            </button>

            {/* Icon */}
            <div style={{ width:52, height:52, borderRadius:14, background:'#E8F1FF', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:16 }}>
              <Icon name="mail" size={24} color="var(--brand)" />
            </div>

            <h3 style={{ fontSize:20, fontWeight:800, color:'#0a0f1e', marginBottom:6 }}>Forgot Password?</h3>
            <p style={{ fontSize:13, color:'#6b748c', marginBottom:20, lineHeight:1.6 }}>
              Enter your registered email address. We'll verify it and let you set a new password.
            </p>

            {forgotError && (
              <div className="auth-alert auth-alert-error" style={{ marginBottom:14 }}>
                <Icon name="alert" size={14} color="var(--danger)" /> {forgotError}
              </div>
            )}

            <div className="auth-field" style={{ marginBottom:16 }}>
              <label className="auth-field-label">Email Address</label>
              <div className="auth-input-wrap">
                <span className="auth-input-icon"><Icon name="mail" size={16} /></span>
                <input type="email" className="auth-input"
                  placeholder="you@example.com" value={forgotEmail}
                  onChange={e => this.setState({ forgotEmail: e.target.value, forgotError: '' })}
                  onKeyDown={e => e.key === 'Enter' && this.handleForgotSubmit()}
                  autoFocus />
              </div>
            </div>

            <button className="auth-btn auth-btn-primary" style={{ width:'100%' }}
              onClick={() => this.handleForgotSubmit()} disabled={forgotLoading}>
              {forgotLoading
                ? <><Icon name="spinner" size={16} color="#fff" className="auth-btn-spinner" /> Checking…</>
                : 'Verify Email →'}
            </button>

            <button type="button" style={{ width:'100%', marginTop:10, border:'none', background:'none', color:'#6b748c', fontSize:13, cursor:'pointer', fontFamily:'inherit' }}
              onClick={() => this.setState({ showForgotModal: false })}>
              Cancel
            </button>
          </div>
        </div>
      )}
      </>
    );
  }
}

export default LoginForm;